import { isApiError } from '../services/sendApiRequest';
import { ApiError } from '../types';

export type MaintenanceStatusPayload = {
  publicMaintenanceMode?: boolean;
};

/** Maps a BFF maintenance response (or transport error) to the UI maintenance flag. */
export function resolveMaintenanceModeFromResponse(
  response: MaintenanceStatusPayload | ApiError,
): boolean {
  if (isApiError(response)) {
    return false;
  }

  return response.publicMaintenanceMode ?? false;
}
